import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { getIsBorderVisible } from '../../store/screenSlice'

import styles from './Border.module.scss'


/* eslint react/prop-types: ["off"] */
function BorderBody({ isVisible }) {
    return (
        <>
            <div className={classNames(styles.left, { [styles.visible]: isVisible })} />
            <div className={classNames(styles.right, { [styles.visible]: isVisible })} />
        </>
    )
}

export const Border = connect(state => ({
    isVisible: getIsBorderVisible(state),
}))(BorderBody)
